import { useEffect, useLayoutEffect, useState } from "react";
import LogoutModal from "../../modals/LogoutModal";
import { useNavigate } from "react-router-dom";
import { Layout, Menu, Row, Col, Drawer, Image } from "antd";
import { AiFillCaretDown } from "react-icons/ai";
import { Badge, Avatar, Dropdown, Popover, Button } from "antd";
import { FaUser, FaSignOutAlt } from "react-icons/fa";
import { FiBell } from "react-icons/fi";
import ClientHeader from "./Header";
import { ImageUrl } from "../../config/helpers";
import { RiDashboardLine } from "react-icons/ri";
import { FaUserFriends } from "react-icons/fa";
import { GiSteeringWheel } from "react-icons/gi";
import { FaCar } from "react-icons/fa";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { BsFillFileEarmarkBarGraphFill } from "react-icons/bs";
import { IoWallet } from "react-icons/io5";
import { IoIosChatbubbles } from "react-icons/io";
// import { LuBadgeDollarSign } from "react-icons/lu";
import { MdMessage } from "react-icons/md";
import { FaPercent } from "react-icons/fa";
import { FaBox } from "react-icons/fa";
import { FaFileContract } from "react-icons/fa";
const { Sider } = Layout;

const sideNavItems = [
  {
    key: 0,
    icon: <RiDashboardLine style={{ fontSize: 20 }} />,
    label: "Dashboard",
    path: "/",
  },
  {
    key: 1,
    icon: <BsFillFileEarmarkBarGraphFill style={{ fontSize: 20 }} />,
    label: "Recent Bookings",
    path: "/recentBooking",
  },
  {
    key: 2,
    icon: <BsFillFileEarmarkBarGraphFill style={{ fontSize: 20 }} />,
    label: "History Bookings",
    path: "/reportManagement",
  },
  {
    key: 3,
    icon: <FaUserFriends style={{ fontSize: 20 }} />,
    label: "Accounts",
    path: "/userManagement",
  },
  {
    key: 4,
    icon: <FaUserFriends style={{ fontSize: 20 }} />,
    label: "Memberships",
    path: "/memberships",
  },
  {
    key: 4.5,
    icon: <FaBox style={{ fontSize: 20 }} />,
    label: "Package Management",
    path: "/membershipPackages",
  },
  {
    key: 5,
    icon: <GiSteeringWheel style={{ fontSize: 20 }} />,
    label: "Chauffeur = A--B",
    path: "/driverManagement",
  },
  {
    key: 6,
    icon: <MdMessage style={{ fontSize: 20 }} />,
    label: "Messages",
    path: "/messages",
  },
  // {
  //   key: 7,
  //   icon: <FaCar style={{ fontSize: 20 }} />,
  //   label: "Reservation Requests",
  //   path: "/reservationRequests",
  // },
  {
    key: 8,
    icon: <FaCar style={{ fontSize: 20 }} />,
    label: "Car Management",
    path: "/carManagement",
  },
  {
    key: 9,
    icon: <FaMoneyCheckDollar style={{ fontSize: 20 }} />,
    label: "Hourly Fare Management",
    path: "/fareManagement",
  },
  {
    key: 10,
    icon: <FaMoneyCheckDollar style={{ fontSize: 20 }} />,
    label: "Distance Fare Management",
    path: "/distanceFare",
  },
  // {
  //   key: 11,
  //   icon: <LuBadgeDollarSign style={{ fontSize: 20 }} />,
  //   label: "Rate Management",
  //   path: "/rateManagement",
  // },
  // {
  //   key: 12,
  //   icon: <LuBadgeDollarSign style={{ fontSize: 20 }} />,
  //   label: "Company Rate",
  //   path: "/companyRate",
  // },
  // {
  //   key: 13,
  //   icon: <LuBadgeDollarSign style={{ fontSize: 20 }} />,
  //   label: "Distance Rate",
  //   path: "/distanceRate",
  // },
  // {
  //   key: 14,
  //   icon: <Ri24HoursLine style={{ fontSize: 20 }} />,
  //   label: "Rush Hour Management",
  //   path: "/rushHourmanagement",
  // },
  {
    key: 15,
    icon: <FaHandHoldingDollar style={{ fontSize: 20 }} />,
    label: "Company Commission",
    path: "/commissionManagement",
  },
  {
    key: 16,
    icon: <IoWallet style={{ fontSize: 20 }} />,
    label: "Payment Logs",
    path: "/paymentLogs",
  },
  {
    key: 17,
    icon: <IoWallet style={{ fontSize: 20 }} />,
    label: "Payment Log Memberships",
    path: "/paymentLogMember",
  },

  {
    key: 18,
    icon: <IoIosChatbubbles style={{ fontSize: 20 }} />,
    label: "Booking Requests",
    path: "/feedbackManagement",
  },
  {
    key: 20,
    icon: <RiDashboardLine style={{ fontSize: 20 }} />,
    label: "Register Chauffeur",
    path: "/registerChauffeur",
  },
  {
    key: 21,
    icon: <BsFillFileEarmarkBarGraphFill style={{ fontSize: 20 }} />,
    label: "Book Chauffeur",
    path: "/bookChauffeur",
  },
  {
    key: 22,
    icon: <FaPercent style={{ fontSize: 20 }} />,
    label: "Pricing Management",
    path: "/discountManagement",
  },
  {
    key: 23,
    icon: <FaFileContract style={{ fontSize: 20 }} />,
    label: "Terms & Conditions",
    path: "/termsAndConditions",
  },
];

const content = (
  <div style={{ width: "350px" }}>
    <div
      style={{
        padding: "10px 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <h3>Notifications</h3>
    </div>
    <hr
      style={{
        borderLeft: "none",
        borderBottom: "none",
        borderRight: "none",
        borderTop: "1px solid rgb(0 0 0 / 15%)",
      }}
    />
    <div style={{ height: "250px", overflow: "auto" }}>
      <div style={{ padding: 10 }}>
        <Row
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            borderBottom: "1px solid #dadada",
          }}
        >
          <Col>
            <p class="notificationText">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Id nam
              veniam aperiam eveniet mollitia quos nemo! Officiis voluptates
              illo delectus.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                25, May 2023
              </p>
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                10:23 PM
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ padding: 10 }}>
        <Row
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            borderBottom: "1px solid #dadada",
          }}
        >
          <Col>
            <p class="notificationText">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Id nam
              veniam aperiam eveniet mollitia quos nemo! Officiis voluptates
              illo delectus.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                25, May 2023
              </p>
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                10:23 PM
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <div style={{ padding: 10 }}>
        <Row
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            borderBottom: "1px solid #dadada",
          }}
        >
          <Col>
            <p class="notificationText">
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Id nam
              veniam aperiam eveniet mollitia quos nemo! Officiis voluptates
              illo delectus.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                25, May 2023
              </p>
              <p
                class="notificationText"
                style={{ color: "black", fontSize: "12px", fontWeight: "bold" }}
              >
                10:23 PM
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <hr
      style={{
        borderLeft: "none",
        borderBottom: "none",
        borderRight: "none",
        borderTop: "1px solid rgb(0 0 0 / 15%)",
      }}
    />

    <div
      style={{
        padding: "10px 20px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Button type="link">View All</Button>
    </div>
  </div>
);

const ClientLayout = ({ children, head }) => {
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [selectedItem, setSelectedItem] = useState("1");
  const navigate = useNavigate();
  const path = window.location.pathname;
  useLayoutEffect(() => {
    // get the path and set selected item to key of the path that matches

    const item = sideNavItems.find((item) => item.path === path);
    if (item) {
      setSelectedItem(item.key.toString());
    } else {
      setSelectedItem("");
    }
  }, [path]);

  const [logoutModal, setLogoutModal] = useState(false);
  const items = [
    {
      key: "1",
      label: (
        <div
          className="headerDropdown"
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            padding: "5px 12px",
          }}
        >
          <FaUser style={{ fontSize: "16px" }} /> &nbsp; My Profile
        </div>
      ),
    },

    {
      key: "2",
      label: (
        <div
          onClick={() => setLogoutModal(true)}
          style={{
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            padding: "5px 12px",
          }}
        >
          <FaSignOutAlt style={{ fontSize: "16px" }} />
          &nbsp; Logout
        </div>
      ),
    },
  ];

  let title = head?.title ? head?.title : "";
  // if (title) {
  //   title = `${SITE_NAME} | ${title}`;
  // } else {
  //   title = SITE_NAME;
  // }

  // set the page title
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <div>
      <Layout
        style={{
          backgroundColor: "white",
          scrollBehavior: "smooth",
          height: "100vh",
        }}
      >
        <Layout style={{ height: "100vh" }}>
          <Row
            className="siderWrapper"
            style={{
              background: "white",
            }}
          >
            <Col xs={0} md={24}>
              <Sider width={280} className="mainSider">
                <br />
                <div className="logoBox">
                  <Image
                    src={ImageUrl("logo-pic.png")}
                    alt="Picture of the author"
                    style={{ maxWidth: "130px" }}
                    preview={false}
                  />
                </div>
                <br />
                <Menu
                  mode="inline"
                  selectedKeys={[selectedItem]}
                  style={{
                    height: "100%",
                    borderRight: 0,
                    background: "transparent",
                    maxHeight: "85vh",
                    overflow: "auto",
                  }}
                >
                  {sideNavItems.map((item) => (
                    <Menu.Item
                      key={item.key}
                      icon={item.icon}
                      onClick={() => {
                        navigate(item.path);
                        setSelectedItem(item.key.toString());
                      }}
                    >
                      {item.label}
                    </Menu.Item>
                  ))}
                </Menu>
              </Sider>
            </Col>
          </Row>
          {/* */}{" "}
          <Layout
            style={{
              padding: "0px",
              // height:"100vh",
              // overflow: "auto",

              position: "relative",
              outline: "none",
            }}
          >
            <ClientHeader
              visible={visible}
              setVisible={setVisible}
              visible2={visible2}
              setVisible2={setVisible2}
            />
            {visible2 && (
              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              >
                <Row style={{ alignItems: "flex-end" }}>
                  <Col xs={24} md={0}>
                    <div
                      style={{
                        backgroundColor: "#2484c6",
                        padding: "20px",
                        display: "flex",
                        position: "absolute",
                        zIndex: 2,
                        width: "100%",
                        justifyContent: "flex-end",
                        transition: "all 0.5s ease-in-out",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Popover
                          content={content}
                          placement="bottom"
                          arrow={false}
                          className="headerPopover"
                        >
                          <Badge
                            count={5}
                            style={{ backgroundColor: "#2484c6" }}
                          >
                            <FiBell
                              style={{ fontSize: "25px", color: "white" }}
                            />
                          </Badge>
                        </Popover>
                        &emsp; &emsp;
                        {/* <Avatar size={40} src="/images/avatar.png" /> */}
                        <Avatar size={40} src={ImageUrl("avatar.png")} />
                        <Dropdown
                          menu={{
                            items,
                          }}
                          trigger={["click"]}
                          placement="bottomRight"
                        >
                          <p
                            style={{
                              marginLeft: 10,
                              fontSize: "16px",
                              color: "white",
                            }}
                          >
                            Masooma Albert <AiFillCaretDown fontSize={12} />{" "}
                          </p>
                        </Dropdown>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            <Layout
              style={{
                padding: "0px",
                // height:"100vh",
                overflow: "auto",
                backgroundColor: "#f4f4f4",
                position: "relative",
                outline: "none",
              }}
            >
              {children}
            </Layout>

            <Drawer
              className="drawer"
              placement="left"
              size="default"
              closable={false}
              onClose={() => setVisible(false)}
              visible={visible}
              getContainer={false}
              key="drawer"
            >
              <Menu
                mode="inline"
                selectedKeys={[selectedItem]}
                style={{
                  height: "100%",
                  borderRight: 0,
                }}
              >
                {sideNavItems.map((item) => (
                  <Menu.Item
                    key={item.key}
                    icon={item.icon}
                    onClick={() => {
                      navigate(item.path);
                      setSelectedItem(item.key.toString());
                      setVisible(false); // Close drawer after clicking
                    }}
                  >
                    {item.label}
                  </Menu.Item>
                ))}
              </Menu>
            </Drawer>
          </Layout>
        </Layout>
      </Layout>
      {logoutModal && (
        <LogoutModal
          logoutModal={logoutModal}
          setLogoutModal={setLogoutModal}
        />
      )}
    </div>
  );
};

export default ClientLayout;
